import { Model } from '../../_kernel/architecture'
import { z } from 'zod'
import { BedType } from './BedType'
import { Description } from '../../_kernel/Description'
import { Count } from '../../_kernel/Count'

export const BedValidation = z.object({
  type: z.instanceof(BedType, { message: '[BED] Invalid bed type' }),
  quantity: z.instanceof(Count, { message: '[BED] Invalid bed quantity' }),
  description: z.instanceof(Description, { message: '[BED] Invalid bed description' }),
})

export class Bed extends Model {
  static create(type: BedType, quantity: Count, description: Description) {
    BedValidation.parse({ type, quantity, description })
    return new Bed(type, quantity, description)
  }

  static fromJSON({ type, quantity, description }: ReturnType<Bed['toJSON']>) {
    return Bed.create(
      BedType.create({ value: type }),
      Count.fromNumber(quantity),
      Description.create({ value: description })
    )
  }

  constructor(
    private readonly _type: BedType,
    private readonly _quantity: Count,
    private readonly _description: Description
  ) {
    super()
  }

  type() {
    return this._type
  }

  quantity() {
    return this._quantity.value
  }

  description() {
    return this._description.value
  }

  toJSON() {
    return {
      type: this._type.value(),
      quantity: this._quantity.value,
      description: this._description.value,
    }
  }
}
